import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

const NAV_ITEMS = [
  { path: "/", icon: "fa-home", label: "Accueil" },
  { path: "/history", icon: "fa-list", label: "Historique" },
  { path: "/support", icon: "fa-headset", label: "Support" },
  { path: "/profile", icon: "fa-user", label: "Profil" },
];

export default function BottomNav() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <div className="bg-white border-t border-gray-100 pt-1.5 pb-2 flex justify-around flex-shrink-0">
      {NAV_ITEMS.map(({ path, icon, label }) => {
        const active = pathname === path;
        return (
          <button
            key={path}
            onClick={() => navigate(path)}
            className="flex flex-col items-center gap-0.5 border-none bg-transparent py-1 px-2 rounded-[9px] tap-highlight cursor-pointer"
          >
            <i
              className={`fa ${icon}`}
              style={{ fontSize: 16, color: active ? "#FF6200" : "#9ca3af" }}
            />
            <span
              className="text-[9px] font-medium"
              style={{ color: active ? "#FF6200" : "#9ca3af" }}
            >
              {label}
            </span>
          </button>
        );
      })}
    </div>
  );
}
